import { useState } from 'react'

export function useToggle() {
  const [open, setOpen] = useState(false)
  const onToggle = () => setOpen((s) => !s)
  return { open, onToggle }
}
